// Browse in the web app — what the read-only viewer shows and deliberately
// doesn't. Sourced from specs/web-app.md and specs/web-viewer.md.

import { IconEye, IconWifi, IconWorldOff } from "@tabler/icons-react";
import { DocSection, K, P, Points } from "../doc-ui";

export function WebAppDoc() {
  return (
    <>
      <P>
        This web app is a live, read-only window into your vaults plus the management surface
        (members, users, server ops). It's handy on machines where you don't want to set up
        Obsidian — a work computer, someone else's laptop, a quick phone check.
      </P>

      <DocSection icon={IconEye} title="Reading vaults">
        <Points>
          <li>The sidebar lists your vaults; inside one, the file tree sits next to the content.</li>
          <li>
            Notes render as Markdown with working wiki-links; images and other attachments load
            inline.
          </li>
          <li>
            Everything is <strong>live</strong>: edits made in Obsidian appear here as they sync,
            and presence dots in the header show who else has the note open right now.
          </li>
          <li>
            <K>History</K> in the header opens a note's version list and preview (restore needs
            editor or owner — see <em>Version history &amp; restore</em>).
          </li>
          <li>
            <K>Clone</K> in the header copies the CLI command that puts this vault on a machine.
          </li>
        </Points>
      </DocSection>

      <DocSection icon={IconWifi} title="The sync status pill">
        <Points>
          <li>
            <K>live</K> — connected; content updates in real time.
          </li>
          <li>
            <K>connecting</K> — establishing or re-establishing the connection.
          </li>
          <li>
            <K>offline</K> — no connection; you're seeing the last-loaded state.
          </li>
          <li>
            <K>error</K> — something's wrong; reload, or check with your server admin.
          </li>
        </Points>
      </DocSection>

      <DocSection
        icon={IconWorldOff}
        title="What the web app doesn't do"
        description="Deliberate scope, not missing features."
      >
        <Points>
          <li>No editing — writing happens in Obsidian, where the plugin syncs it.</li>
          <li>No search, graph view, or canvas — those are Obsidian features.</li>
          <li>No public sharing or publishing — every page here requires signing in.</li>
        </Points>
      </DocSection>
    </>
  );
}
